import * as React from 'react'
import { Filter, FilterProps } from 'react-admin'
import { UserListFiltersArray } from './Filters'

const UserListFilters: React.FC<Omit<FilterProps, 'children'>> = (props) => {
  return (
    <Filter {...props}>
      {UserListFiltersArray.map((item) => item.FilterInput)}
    </Filter>
  )
}

export default UserListFilters
